import React from 'react';

const MapReplay = () => {
  return (
    <div style={{ padding: 16 }}>
      <h2 style={{ marginBottom: 8 }}>Map Replay</h2>
      <div style={{ color: '#64748b' }}>Coming soon</div>
    </div>
  );
};

export default MapReplay;
